// ── Home links (logo + "Home" nav item) ─────────────────────────
// On the homepage, clicking a link to "/" scrolls to top instead of
// reloading. On any other page, the browser just navigates to "/" as
// normal, which already lands at the top.
document.querySelectorAll('a[href="/"]').forEach(link => {
  link.addEventListener('click', e => {
    if (window.location.pathname === '/') {
      e.preventDefault()
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
  })
})

// ── "Produkty" nav link → jump straight to #product-categories ─────────
// /collections/all still exists only as a redirect target (see
// templates/collection.liquid) for old/external links. From the navbar
// itself we skip that hop entirely: on the homepage, scroll straight to
// the section; anywhere else, navigate directly to the anchored homepage
// URL instead of bouncing through /collections/all first.
document.querySelectorAll('a[href="/collections/all"], a[href$="/collections/all"]').forEach(link => {
  link.addEventListener('click', e => {
    e.preventDefault()
    const target = document.getElementById('product-categories')
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' })
    } else {
      window.location.href = '/#product-categories'
    }
  })
})

// ── Mobile menu ──────────────────────────────────────────────
const menuBtn = document.getElementById('mobile-menu-btn')
const mobileMenu = document.getElementById('mobile-menu')

if (menuBtn && mobileMenu) {
  menuBtn.addEventListener('click', () => {
    mobileMenu.classList.toggle('is-open')
    const isOpen = mobileMenu.classList.contains('is-open')
    menuBtn.setAttribute('aria-expanded', isOpen)
  })
}

// ── Quantity input ────────────────────────────────────────────
document.querySelectorAll('.qty-wrap').forEach(wrap => {
  const input = wrap.querySelector('.qty-input')
  wrap.querySelector('.qty-minus')?.addEventListener('click', () => {
    const val = parseInt(input.value) || 1
    if (val > 1) input.value = val - 1
  })
  wrap.querySelector('.qty-plus')?.addEventListener('click', () => {
    input.value = (parseInt(input.value) || 1) + 1
  })
})

// ── Cart item removal ──────────────────────────────────────────
document.querySelectorAll('[data-remove-item]').forEach(btn => {
  btn.addEventListener('click', () => {
    const input = document.getElementById(btn.dataset.qtyInput)
    if (!input) return
    input.value = 0
    btn.closest('form')?.requestSubmit()
  })
})

// ── Cart: document type (paragon / faktura) + NIP lookup ──────────────
// For a VAT invoice the customer enters a NIP and the company name/address
// are fetched from the MF VAT register (Biała lista). The values travel as
// cart attributes; inputs are disabled while "Paragon" is selected so nothing
// invoice-related is submitted then.
const cartForm = document.getElementById('cart-form')
const checkoutBtn = document.getElementById('cart-checkout-btn')
const consentCheckbox = document.getElementById('cart-consent-policies')
const consentError = document.getElementById('consent-error')

const docBox = document.getElementById('cart-doc')
const docError = document.getElementById('doc-error')
let docIsInvoice = () => false
let docNipIsValid = () => true

if (docBox) {
  const docRadios = docBox.querySelectorAll('input[name="attributes[Dokument sprzedaży]"]')
  const invoiceBox = document.getElementById('cart-doc-invoice')
  const nipInput = document.getElementById('cart-doc-nip')
  const nameInput = document.getElementById('cart-doc-name')
  const addressInput = document.getElementById('cart-doc-address')
  const lookupBtn = document.getElementById('cart-doc-lookup')
  const statusEl = document.getElementById('cart-doc-status')
  const streetInput = document.getElementById('cart-doc-street')
  const zipInput = document.getElementById('cart-doc-zip')
  const cityInput = document.getElementById('cart-doc-city')
  const flagInput = document.getElementById('cart-doc-flag')
  const wantInput = document.getElementById('cart-doc-want')
  const invoiceInputs = [nipInput, nameInput, addressInput, streetInput, zipInput, cityInput]

  let lookupToken = 0
  let lookedUpNip = ''

  docIsInvoice = () => Array.from(docRadios).some(r => r.checked && r.value === 'Faktura VAT')

  function normalizeNip(value) {
    return value.replace(/^\s*pl/i, '').replace(/\D/g, '')
  }

  function isValidNip(nip) {
    if (!/^\d{10}$/.test(nip)) return false
    const weights = [6, 5, 7, 2, 3, 4, 5, 6, 7]
    const sum = weights.reduce((acc, w, i) => acc + w * Number(nip[i]), 0)
    const check = sum % 11
    return check !== 10 && check === Number(nip[9])
  }

  // "ulica 1/2, 00-000 Miejscowość" -> street / postcode / city, or null.
  function parseAddress(value) {
    const match = value.trim().match(/^(.+?),\s*(\d{2}-\d{3})\s+(.+)$/)
    return match ? { street: match[1].trim(), zip: match[2], city: match[3].trim() } : null
  }

  function syncAddressParts() {
    const parts = parseAddress(addressInput.value)
    streetInput.value = parts ? parts.street : addressInput.value.trim()
    zipInput.value = parts ? parts.zip : ''
    cityInput.value = parts ? parts.city : ''
  }

  function setStatus(message, kind) {
    if (!message) {
      statusEl.hidden = true
      statusEl.textContent = ''
      return
    }
    statusEl.textContent = message
    statusEl.dataset.kind = kind || 'info'
    statusEl.hidden = false
  }

  // Data from the register is read-only; if the lookup fails the customer can
  // type the company data by hand.
  function setLocked(locked) {
    nameInput.readOnly = locked
    addressInput.readOnly = locked
  }

  function syncInvoiceVisibility() {
    const on = docIsInvoice()
    invoiceBox.hidden = !on
    flagInput.value = on ? 'Tak' : 'Nie'
    wantInput.value = on ? '1' : '0'
    invoiceInputs.forEach(input => { input.disabled = !on })
    docError.hidden = true
  }

  async function lookupNip() {
    const nip = normalizeNip(nipInput.value)
    nipInput.value = nip

    if (!isValidNip(nip)) {
      setLocked(false)
      setStatus('Nieprawidłowy numer NIP. Sprawdź i spróbuj ponownie.', 'error')
      return
    }

    const token = ++lookupToken
    lookupBtn.disabled = true
    setStatus('Pobieranie danych firmy…', 'info')

    const controller = new AbortController()
    const timer = setTimeout(() => controller.abort(), 8000)

    try {
      const date = new Date().toISOString().slice(0, 10)
      const response = await fetch(`https://wl-api.mf.gov.pl/api/search/nip/${nip}?date=${date}`, {
        signal: controller.signal
      })
      if (token !== lookupToken) return
      if (!response.ok) throw new Error('bad status')

      const data = await response.json()
      if (token !== lookupToken) return
      const subject = data?.result?.subject
      lookedUpNip = nip

      if (subject && subject.name) {
        nameInput.value = subject.name
        addressInput.value = subject.workingAddress || subject.residenceAddress || ''
        syncAddressParts()
        const parsed = Boolean(parseAddress(addressInput.value))
        setLocked(parsed)
        setStatus(parsed
          ? 'Dane firmy pobrane z rejestru VAT.'
          : 'Pobrano nazwę firmy. Uzupełnij adres w formacie: ulica numer, 00-000 Miejscowość.', parsed ? 'ok' : 'info')
      } else {
        setLocked(false)
        setStatus('Nie znaleziono firmy w rejestrze VAT. Wpisz dane ręcznie.', 'info')
      }
    } catch (err) {
      if (token !== lookupToken) return
      lookedUpNip = nip
      setLocked(false)
      setStatus('Nie udało się pobrać danych. Wpisz je ręcznie.', 'info')
    } finally {
      clearTimeout(timer)
      if (token === lookupToken) lookupBtn.disabled = false
    }
  }

  addressInput.addEventListener('input', syncAddressParts)
  docRadios.forEach(radio => radio.addEventListener('change', syncInvoiceVisibility))
  lookupBtn.addEventListener('click', lookupNip)

  nipInput.addEventListener('input', () => {
    const nip = normalizeNip(nipInput.value)
    if (lookedUpNip && nip !== lookedUpNip) {
      lookedUpNip = ''
      nameInput.value = ''
      addressInput.value = ''
      syncAddressParts()
      setLocked(false)
      setStatus('')
    }
    if (nip.length === 10) lookupNip()
  })

  docNipIsValid = () => isValidNip(normalizeNip(nipInput.value))

  if (docIsInvoice() && docNipIsValid() && !nameInput.value) lookupNip()
}

// Only the "go to checkout" submit is guarded — quantity updates pass through.
cartForm?.addEventListener('submit', e => {
  if (e.submitter !== checkoutBtn) return

  if (docError) docError.hidden = true
  if (consentError) consentError.style.display = 'none'

  if (docBox && docIsInvoice()) {
    const name = docBox.querySelector('#cart-doc-name').value.trim()
    const addressOk = Boolean(docBox.querySelector('#cart-doc-zip').value && docBox.querySelector('#cart-doc-city').value)
    if (!docNipIsValid() || !name || !addressOk) {
      e.preventDefault()
      docError.textContent = !docNipIsValid()
        ? 'Aby otrzymać fakturę VAT, podaj poprawny numer NIP.'
        : !name
          ? 'Aby otrzymać fakturę VAT, podaj nazwę firmy.'
          : 'Podaj adres firmy w formacie: ulica numer, 00-000 Miejscowość.'
      docError.hidden = false
      docBox.scrollIntoView({ behavior: 'smooth', block: 'center' })
      return
    }
  }

  if (consentCheckbox && !consentCheckbox.checked) {
    e.preventDefault()
    consentError.textContent = 'Zaakceptuj regulamin i polityki sklepu, aby przejść do kasy.'
    consentError.style.display = ''
  }
})

// ── Collection filter ─────────────────────────────────────────
function applyFilter(filter) {
  document.querySelectorAll('.filter-btn').forEach(b => b.classList.remove('is-active'))
  const activeBtn = document.querySelector(`.filter-btn[data-filter="${filter}"]`)
  if (activeBtn) activeBtn.classList.add('is-active')

  document.querySelectorAll('.product-card').forEach(card => {
    const line = card.dataset.line
    card.closest('.product-card-wrap').style.display =
      filter === 'all' || line === filter ? '' : 'none'
  })
}

document.querySelectorAll('.filter-btn').forEach(btn => {
  btn.addEventListener('click', () => applyFilter(btn.dataset.filter))
})

// Apply filter from URL on load, e.g. /collections/all?filter=Classic
const urlFilter = new URLSearchParams(location.search).get('filter')
if (urlFilter && document.querySelector(`.filter-btn[data-filter="${urlFilter}"]`)) {
  applyFilter(urlFilter)
}

// ── Product card image slideshow on hover ─────────────────────
function pcStartSlide(card) {
  var raw = card.dataset.images || ''
  var images = raw.split('||').filter(function(s) { return s.trim() !== '' })
  if (images.length < 2) return

  var img = card.querySelector('.pc-img')
  if (!img) return

  var idx = 0
  card._pcSlide = setInterval(function() {
    idx = (idx + 1) % images.length
    img.style.opacity = '0'
    img.style.transition = 'opacity .25s'
    setTimeout(function() {
      img.src = images[idx]
      img.style.opacity = '1'
    }, 200)
  }, 2000)
}

function pcStopSlide(card) {
  clearInterval(card._pcSlide)
  var img = card.querySelector('.pc-img')
  if (img) {
    img.style.opacity = '1'
  }
}

// ── Add to cart (AJAX) + success notification ─────────────────
const cartOverlay = document.getElementById('cart-success-overlay')
const cartProductLabel = document.getElementById('cart-success-product')

function openCartSuccess(productTitle) {
  if (!cartOverlay) return
  cartProductLabel.textContent = productTitle || ''
  cartOverlay.classList.add('is-open')
}

function closeCartSuccess() {
  cartOverlay?.classList.remove('is-open')
}

cartOverlay?.addEventListener('click', e => {
  if (e.target === cartOverlay) closeCartSuccess()
})
document.getElementById('cart-success-continue')?.addEventListener('click', closeCartSuccess)
document.addEventListener('keydown', e => {
  if (e.key === 'Escape') closeCartSuccess()
})

function updateCartCount(count) {
  document.querySelectorAll('.js-cart-count').forEach(el => {
    el.textContent = count
    el.style.display = count > 0 ? '' : 'none'
  })
}

document.addEventListener('submit', e => {
  const form = e.target
  if (!(form instanceof HTMLFormElement)) return
  if (!form.action || new URL(form.action, window.location.origin).pathname !== '/cart/add') return

  e.preventDefault()
  const submitBtn = form.querySelector('[type="submit"]')
  if (submitBtn) submitBtn.disabled = true

  fetch('/cart/add.js', {
    method: 'POST',
    body: new FormData(form),
    headers: { Accept: 'application/json' }
  })
    .then(res => res.json().then(data => ({ ok: res.ok, data })))
    .then(({ ok, data }) => {
      if (!ok) {
        alert(data.description || 'Nie udało się dodać produktu do koszyka.')
        return
      }
      openCartSuccess(data.product_title || data.title)
      return fetch('/cart.js')
        .then(res => res.json())
        .then(cart => updateCartCount(cart.item_count))
    })
    .catch(() => {
      alert('Nie udało się dodać produktu do koszyka. Spróbuj ponownie.')
    })
    .finally(() => {
      if (submitBtn) submitBtn.disabled = false
    })
})
